module.exports = __webpack_public_path__ + "static/media/picture rftag.9f3354a2.jpg";